// import React, { useState } from 'react';
// import { useJobContext } from '../../context/JobContext';
// import api from '../../components/Api';
// import { Input, Selectbox } from '../../css/Shared';
// import { toast } from 'react-toastify';
// import { useNavigate } from 'react-router-dom';
// import { useAppContext } from '../../context/AppContext';

// const ReviewTab = ({goToPrevTab}) => {
//   const { formData, finalCSV, csvMeta, setFormData } = useJobContext();
//   const{authState} = useAppContext()
//   const [loading, setLoading] = useState(false);
// const nav = useNavigate()

// console.log(authState)
// console.log(formData)
// const v = (val) => val ?? '';

// const AccuString = `
// ThisForm.Textboxstandard1.Value=[${v(formData?.jobDescription)}]

// ThisForm.Textboxstandard4.Value=[]

// ThisForm.Textboxstandard5.Value=[${v(formData?.provider?.repname)}]

// ThisForm.Textboxstandard6.Value=[${v(formData?.provider?.repphone)}]

// ThisForm.Textboxstandard7.Value=[${v(formData?.product?.weight)}]

// ThisForm.Textboxstandard8.Value=[${v(formData?.permit?.permitNumber)}]

// ThisForm.NetPostageDueNo.Value=[${v(formData?.permit?.dueNetNumber)}]

// ThisForm.Textboxstandard26.Value=[]

// ThisForm.Textboxstandard9.Value=[${v(formData?.permit?.phone)}]

// ThisForm.Textboxstandard10.Value=[${v(formData?.provider?.providerName)}]

// ThisForm.Textboxstandard11.Value=[]

// ThisForm.Textboxstandard27.Value=[]

// ThisForm.Textboxstandard12.Value=[${v(formData?.provider?.crid) || ""}]

// ThisForm.Textboxstandard29.Value=[]

// ThisForm.Textboxstandard36.Value=[]

// ThisForm.Textboxstandard42.Value=[]

// ThisForm.Textboxstandard25.Value=[${v(formData?.provider?.mid)}]

// ThisForm.Textboxstandard13.Value=[]

// ThisForm.Textboxstandard35.Value=[]

// ThisForm.Textboxstandard14.Value=[${v(formData?.owner?.crid)}]

// ThisForm.Textboxstandard33.Value=[${v(formData?.owner?.anywhere)}]

// ThisForm.Textboxstandard34.Value=[]

// ThisForm.Checkstandard6.Value=1

// ThisForm.Textboxstandard28.Value=[]

// ThisForm.Textboxstandard15.Value=[${v(formData?.permit?.nonprofitnumber)}]

// ThisForm.Textboxstandard16.Value=[]

// ThisForm.Textboxstandard17.Value=[${v(formData?.provider?.repphone)}]

// ThisForm.Textboxstandard30.Value=[${v(formData?.provider?.repemail)}]

// ThisForm.Textboxstandard18.Value=[${v(formData?.product?.name)}]

// ThisForm.Textboxstandard20.Value=[]

// ThisForm.Textboxstandard21.Value=[]

// ThisForm.Standardcombo1.Value=[Labels]

// ThisForm.Standardcombo2.Value=[${v(formData?.permit?.permitType)}]

// ThisForm.Standardcombo4.Value=[Ghost Permit]

// ThisForm.Standardcombo3.Value=[NCOALink]

// ThisForm.Standardcombo5.Value=[]

// ThisForm.Standardcombo6.Value=[]

// ThisForm.Standardcombo7.Value=[2-tracking File]

// ThisForm.Textboxstandard37.Value=[]

// ThisForm.Textboxstandard38.Value=[]

// ThisForm.Textboxstandard39.Value=[]

// ThisForm.Edit1.Value=[${v(formData?.permit?.companyName)}^
// ${v(formData?.permit?.address)}^
// ${v(formData?.permit?.city)}, ${v(formData?.permit?.state)} ${v(formData?.permit?.zip)}]

// ThisForm.Edit2.Value=[${v(formData?.owner?.companyName)}^
// ${v(formData?.owner?.address)}^
// ${v(formData?.owner?.city)}, ${v(formData?.owner?.state)} ${v(formData?.owner?.zip)}]

// ThisForm.Edit3.Value=[${v(formData?.provider?.providerName)}^
// ${v(formData?.provider?.address)}^
// ${v(formData?.provider?.city)}, ${v(formData?.provider?.state)} ${v(formData?.provider?.zip)}]

// ThisForm.Checkstandard1.Value=0

// ThisForm.Checkstandard2.Value=0

// ThisForm.Checkstandard3.Value=0

// ThisForm.Textboxstandard22.Value=[${v(formData?.dropshipname)}]

// ThisForm.Textboxstandard32.Value=[${formData.permit.bmeuFacility?.dropdelzpp.substr(0,5)}-${formData.permit.bmeuFacility?.dropdelzpp.substr(5,9)}]

// ThisForm.CheckStandard7.Value=0

// ThisForm.Textboxstandard23.Value=[]
// `;

//   const handleSubmitJob = async () => {
//     if (!finalCSV ) {
//       alert('No CSV file found.');
//       return;
//     }

//     setLoading(true);


// console.log(formData)
//     try {

// const payload = {
//   jobDescription: formData.jobDescription || "",
//   mailClass: formData.mailClass || "",
//   mailDate: formData.mailDate || "",
//   mailShape: formData.mailShape || "",
//     aspectRatio: formData.aspectRatio || 0,

//   political:formData.political || 0,
//    imbarcode:formData.imbarcode || 0,
//    einduction:formData.einduction || 0,
//    ncoa:formData.ncoa || 0,
//    alreadyNcoa:formData.alreadyNcoa || 0,
//    ncoaDate:formData.ncoaDate || "",
//    currentResident:formData.currentResident || 0,
//    radiusZip:formData.radiusZip || "",
//    radiusMiles:formData.radiusMiles || "",
//    restrictStates:formData.restrictStates || "",
//    removeMoved:formData.removeMoved || 0,
//    sortation:formData.sortation || "",
//     reason:formData.reason || "",
//   IMbarcode:formData.IMbarcode || 0,
//   ballotbox:formData.ballotbox || 0,
//   dropship:formData.dropship || 0,
//   dropshipname:formData.dropshipname || "",
//   growthIncentive:formData.growthIncentive || "",
//   no1Trays:formData.no1Trays || "",
//   political:formData.political || 0,
//   promotions:formData.promotions || 0,
//   basepromotions:formData.basepromotions || "",
//   smallPallets:formData.smallPallets || "",
//   unevenThickness:formData.unevenThickness || 0,
//   tallPallets:formData.tallPallets || "",
//   uspsJobId:formData.uspsJobId || "",
//   addon1:formData.addon1 || "",
//   addon2: formData.addon2 || "",
//   AccuString:AccuString.trim().replace(/\n\n/g, String.fromCharCode(13,10)),
//     company:authState?.user?.company || "",
//     user:authState?.user || "",
//   permit:formData.permit || "",
//     owner:formData.owner || "",
// product:formData.product || "",
//   provider:formData.provider || "",
//   poe:formData.poe || formData.provider?.bmeuFacility,


// };
//   console.log(payload)

//       const form = new FormData();  //,chris.carten@lightningpresort.com
//       form.append('recipient', 'summanusb@gmail.com');
//       form.append('formData', JSON.stringify(payload));
//       form.append('csvFile', finalCSV, `${formData.jobDescription || 'job'}.csv`);

//       console.log(payload)
//       await api.post('/jobs/processJob', form, {
//         headers: { 'Content-Type': 'multipart/form-data' }
//       });
//   toast.success('Job Successfully Uploaed')
//   //nav('/dashboard')
//     } catch (err) {
//       console.error(err);
//       toast.success(err.response?.data?.error || err.message)
    
//     } finally {
//       setLoading(false);
//     }
//   };



//  const formatAddress = (address) => {
//   if (!address) return null;

//   const index = address.indexOf(',');

//   // no comma found → render as-is
//   if (index === -1) return address;

//   const firstLine = address.slice(0, index);
//   const rest = address.slice(index + 1).trim();

 

//   return (
//     <>
//       {firstLine}
//       <br />
//       {rest}
//     </>
//   );
// };




//     const permitfields = [
//   { label: 'Permit Number:', key: '',value:formData?.permit?.permitNumber},
//    { label: 'Post Office:', key: '',value:  formatAddress(formData?.permit?.bmeu)},
  
// ];





//    const providerfields = [
//   { label: 'Address', key: 'telephone',value:<>{formData?.provider?.address} {formData?.provider?.address2}<br />{formData?.provider?.city}, {formData?.provider?.state} {formData?.provider?.zip}</> },
//   { label: 'eInduction ', key: 'capsCustRef',value:'No' },
//   { label: 'Seamless Acceptance', key: '',value:'No' },
// ];
//    const ownerfields = [
//   { label: 'Nonprofit:', key: '',value:"No" },

// ];

//  const handlePrev = () => {
   
//     goToPrevTab();
//   };



// console.log(formData)
//   return (
//     <div className="p-4 max-w-6xl mx-auto font-sans space-y-4 text-xs">
    

// <div style={{fontSize:'clamp(1.3rem,1.3rem,1.6rem)',textAlign:'center'}}>Job Description / Title: {formData?.jobDescription}</div>
//       {/* CSV Info */}
    
      
//    <div
//   style={{
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '14px',
//   }}
//   className="md:flex-row md:gap-4"
// ><div style={{display:'flex',gap:'20px'}}>
//   <div className="md:flex-1">
//     <span style={{ fontSize: 'clamp(.9rem, .9rem, 1.2rem)' }}>
//       Mail Class:
//     </span>{' '}
//     {formData.mailClass}
//   </div>
//   <div style={{flex:'1',textAlign:'right'}}>File: {csvMeta.name}</div>

// </div>
// <div style={{display:'flex',gap:'20px'}}>
//   <div style={{flex:'1'}}>
//     <span style={{ fontSize: 'clamp(.9rem, .9rem, 1.2rem)' }}>
//       Mail Date:
//     </span>{' '}
//     {formData.mailDate}
//   </div>
//     <div  style={{flex:'1',textAlign:'right'}}>
        
//        Records:{csvMeta.records}
//       </div>
//       </div>
// </div>

//       <hr />
//       {/* Permit Holder / Mailing Agent / Individual */}
//       <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
//         {/* Permit Holder */}
//         <div>
//   <h4 className="font-semibold mb-1 text-[12px]">Permit Info - {formData?.permit?.permitName}</h4>
//   <div className="p-2 rounded border border-gray-300 bg-gray-50" style={{ padding: '8px' }}>
//     <p style={{ fontSize: 'clamp(.9rem, .9rem, 1.2rem)' }}>{formData?.permit?.companyName}</p>
//     <p style={{ fontSize: 'clamp(.9rem, .9rem, 1.2rem)' }}>
//       {formData?.permit?.address} {formData?.permit?.address2}
//     </p>
//     <p style={{ fontSize: 'clamp(.9rem, .9rem, 1.2rem)' }}>
//       {formData?.permit?.city}, {formData?.permit?.state} {formData?.permit?.zip}
//     </p>
//   </div>
// {permitfields.map(({ label, key, value }) => (
//   <div
//     key={key}
//     style={{
   
//       fontSize: 'clamp(.9rem, .9rem, 1.2rem)',
//       display: 'flex',
//       justifyContent: 'space-between',
//       marginTop: '4px',
//       gap:'16px'
//     }}
//   >
//     <div style={{ fontSize: 'clamp(.7rem, .7rem, .9rem)' }}>{label} </div>
//     <div
//       type="text"
//       style={{
//         flex:'1.5',
//            textAlign:'right',
//      whiteSpace: 'normal',
// wordBreak: 'keep-all',

//         fontSize: 'clamp(.7rem, .7rem, .9rem)',
//         paddingRight:'5px'
//       }}>
//         {value}
//  </div>
//   </div>
// ))}
// </div>


//         {/* Mailing Agent */}
//       <div>
//   <h4 className="font-semibold mb-1 text-[12px]">Mail Service Provider - {formData?.provider?.providerName}</h4>
//   <div className="p-2 rounded border border-gray-300 bg-gray-50" style={{ padding: '8px' }}>
//     <p style={{ fontSize: 'clamp(.9rem, .9rem, 1.2rem)' }}>{formData?.provider?.providerName}</p>
//     <p style={{ fontSize: 'clamp(.9rem, .9rem, 1.2rem)' }}>
//       {formData?.provider?.address} {formData?.provider?.address2}
//     </p>
//     <p style={{ fontSize: 'clamp(.9rem, .9rem, 1.2rem)' }}>
//       {formData?.provider?.city}, {formData?.provider?.state} {formData?.provider?.zip}
//     </p>
//   </div>
// {providerfields.map(({ label, key, value }) => (
//   <div
//     key={key}
//     style={{
//       fontSize: 'clamp(.9rem, .9rem, 1.2rem)',
//       display: 'flex',
//       justifyContent: 'space-between',
//       marginTop: '4px',
//     }}
//   >
//    <div style={{ fontSize: 'clamp(.7rem, .7rem, .9rem)' }}>{label} </div>
//    <div
//       type="text"
//       style={{
//         flex:'1.5',
//            textAlign:'right',
//      whiteSpace: 'normal',
// wordBreak: 'keep-all',

//         fontSize: 'clamp(.7rem, .7rem, .9rem)',
//         paddingRight:'5px'
//       }}>
//         {value}
//  </div>
//   </div>
// ))}

// </div>

//         {/* Individual / Organization */}
//       <div>
//   <h4 className="font-semibold mb-1 text-[12px]">Mail Owner - {formData?.owner?.companyName}</h4>
//   <div className="p-2 rounded border border-gray-300 bg-gray-50" style={{ padding: '8px' }}>
//     <p style={{ fontSize: 'clamp(.9rem, .9rem, 1.2rem)' }}>{formData?.owner?.companyName}</p>
//     <p style={{ fontSize: 'clamp(.9rem, .9rem, 1.2rem)' }}>
//       {formData?.owner?.address} {formData?.owner?.address2}
//     </p>
//     <p style={{ fontSize: 'clamp(.9rem, .9rem, 1.2rem)' }}>
//       {formData?.owner?.city}, {formData?.owner?.state} {formData?.owner?.zip}
//     </p>
//   </div>
// {ownerfields.map(({ label, key,value }) => (
//   <div
//     key={key}
//     style={{
//       fontSize: 'clamp(.9rem, .9rem, 1.2rem)',
//       display: 'flex',
//       gap:'1-px',
//       justifyContent: 'space-between',
//       marginTop: '4px',
//     }}
//   >
//     <div style={{ fontSize: 'clamp(.7rem, .7rem, .9rem)', marginLeft: '8px' }}>{label}</div>
//      <div
//       type="text"
//       style={{
//         flex:'1.5',
//            textAlign:'right',
//      whiteSpace: 'normal',
// wordBreak: 'keep-all',

//         fontSize: 'clamp(.7rem, .7rem, .9rem)',
//         paddingRight:'5px'
//       }}>
//         {value}
//  </div>
//   </div>
// ))}

// </div>
//       </div>

   

//       {/* Product Info */}
//       <div>
//         <h4 className="font-semibold mb-1 text-[12px]">Product Information</h4>
//         <div className="p-2 rounded border border-gray-300 bg-gray-50 grid grid-cols-1 md:grid-cols-5 gap-2 text-[12px]">
//           <div style={{fontSize:'clamp(.9rem, .9rem, .9rem)'}} >
//             <p style={{fontSize:'clamp(.9rem, .9rem, .9rem)'}}><span style={{fontSize:'clamp(.9rem, .9rem, .9rem)'}}>Product Name:</span> <br />{formData.product?.name}</p>
//           </div>
         
//           <div style={{fontSize:'clamp(.9rem, .9rem, .9rem)'}}>
//             <p style={{fontSize:'clamp(.9rem, .9rem, .9rem)'}}><span style={{fontSize:'clamp(.9rem, .9rem, .9rem)'}}>Size:</span> <br />{formData.product?.length} X {formData.product?.width}</p>
//           </div>
//           <div style={{fontSize:'clamp(.9rem, .9rem, .9rem)'}}>
//              <p style={{fontSize:'clamp(.9rem, .9rem, .9rem)'}}><span style={{fontSize:'clamp(.9rem, .9rem, .9rem)'}}>Thickness:</span><br /> {formData.product?.thickness} </p>
//           </div>
//            <div style={{fontSize:'clamp(.9rem, .9rem, .9rem)'}}>
//              <p style={{fontSize:'clamp(.9rem, .9rem, .9rem)'}}><span style={{fontSize:'clamp(.9rem, .9rem, .9rem)'}}>Weight:</span><br /> {formData.product?.weight} </p>
//           </div>
//             <div style={{fontSize:'clamp(.9rem, .9rem, .9rem)'}}>
//              <p style={{fontSize:'clamp(.9rem, .9rem, .9rem)'}}><span style={{fontSize:'clamp(.9rem, .9rem, .9rem)'}}>Style:</span><br /> {formData?.mailShape} </p>
//           </div>
//         </div>
//       </div>

//     {/* ================= List Cleaning / Data Cleanup (Read-Only) ================= */}
// <div className="mt-4 p-4 border rounded bg-gray-50 text-xs space-y-4">
//   <h4 className="font-semibold text-[12px] mb-2">List Cleaning Options</h4>

//   {/* NCOA / Current Resident */}
//   <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//     <div>
//       <span className="font-medium">Are we NCOA’ing the List?</span>
//       <div>{formData.ncoa ? 'Yes' : 'No'}</div>
//     </div>

//     {formData.ncoa === false && (
//       <div>
//         <span className="font-medium">Already been NCOA’d?</span>
//         <div>
//           {formData.alreadyNcoa === null
//             ? 'N/A'
//             : formData.alreadyNcoa
//             ? 'Yes'
//             : 'No'}
//         </div>
//       </div>
//     )}

//     {formData.ncoa === false && formData.alreadyNcoa === true && (
//       <div>
//         <span className="font-medium">Date of NCOA</span>
//         <div>{formData.ncoaDate || 'N/A'}</div>
//       </div>
//     )}

//     {formData.ncoa === false && formData.alreadyNcoa === false && (
//       <div>
//         <span className="font-medium">Current Resident Mailing?</span>
//         <div>{formData.currentResident ? 'Yes' : 'No'}</div>
//       </div>
//     )}
//   </div>

//   {/* Address Filtering */}
//   <div className="border-t pt-2">
//     <div className="font-medium mb-1">Address Filtering</div>
//     <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-1">
//       <div>
//         <span className="font-medium">Radius Zipcode:</span> {formData.radiusZip || 'N/A'}
//       </div>
//       <div>
//         <span className="font-medium">Radius (Miles):</span> {formData.radiusMiles || '0.0'}
//       </div>
//     </div>

//     {/* Checkboxes */}
//     <div className="flex flex-wrap gap-4 mt-2">
//       <div>
//         <span className="font-medium">Remove all records that moved:</span> {formData.removeMoved ? 'Yes' : 'No'}
//       </div>
//       <div>
//         <span className="font-medium">Remove duplicate records:</span> {formData.dedup ? 'Yes' : 'No'}
//       </div>
//       <div>
//         <span className="font-medium">Remove bad addresses:</span> {formData.removeBadAddress ? 'Yes' : 'No'}
//       </div>
//     </div>
//   </div>

//   {/* Suppression / Seed Lists */}
//  {/* Suppression / Seed Lists */}
// <div className="border-t pt-2 grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
//   <div>
//     <span className="font-medium">Do Not Mail (Suppression) List:</span> {formData.dnmMode || 'None'}
//     {formData.selectedSuppressionLists && Object.keys(formData.selectedSuppressionLists).length > 0 && (
//       <ul className="ml-2 text-[11px] list-disc list-inside">
//         {Object.values(formData.selectedSuppressionLists).map((list, idx) => (
//           <div key={idx}>
//             {list.name} ({list.count} addresses)
//           </div>
//         ))}
//       </ul>
//     )}
//   </div>
//   <div>
//     <span className="font-medium">Seed Records:</span> {formData.seedMode || 'None'}
//     {formData.selectedSeedLists && Object.keys(formData.selectedSeedLists).length > 0 && (
//       <ul className="ml-2 text-[11px] list-disc list-inside">
//         {Object.values(formData.selectedSeedLists).map((list, idx) => (
//           <div key={idx}>
//             {list.name} ({list.count} seeds)
//           </div>
//         ))}
//       </ul>
//     )}
//   </div>
// </div>
// </div>

//       {/* Submit Button */}
//       <div className="flex justify-end">
//          <button
//          style={{marginRight:'30px'}}
//     onClick={handlePrev}
//     className="bg-blue-500 text-white px-4 py-1 rounded hover:bg-blue-600"
//   >
//     Prev &lt;
//   </button>
//         <button
//           onClick={handleSubmitJob}
//           disabled={loading}
//           className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-1 rounded text-sm font-semibold"
//         >
//           {loading ? 'Submitting...' : 'Submit Job'}
//         </button>
//       </div>

      
//     </div>
//   );
// };

// export default ReviewTab;






import React, { useState } from 'react';
import { useJobContext } from '../../context/JobContext';
import api from '../../components/Api';
import { Input, Selectbox } from '../../css/Shared';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../context/AppContext';

const ReviewTab = ({ goToPrevTab }) => {
  const { formData, finalCSV, csvMeta, setFormData } = useJobContext();
  const { authState } = useAppContext();
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const v = (val) => val ?? '';

  const AccuString = `
ThisForm.Textboxstandard1.Value=[${v(formData?.jobDescription)}]
ThisForm.Textboxstandard4.Value=[]
ThisForm.Textboxstandard5.Value=[${v(formData?.provider?.repname)}]
ThisForm.Textboxstandard6.Value=[${v(formData?.provider?.repphone)}]
ThisForm.Textboxstandard7.Value=[${v(formData?.product?.weight)}]
ThisForm.Textboxstandard8.Value=[${v(formData?.permit?.permitNumber)}]
ThisForm.NetPostageDueNo.Value=[${v(formData?.permit?.dueNetNumber)}]
ThisForm.Textboxstandard26.Value=[]
ThisForm.Textboxstandard9.Value=[${v(formData?.permit?.phone)}]
ThisForm.Textboxstandard10.Value=[${v(formData?.provider?.providerName)}]
ThisForm.Textboxstandard11.Value=[]
ThisForm.Textboxstandard27.Value=[]
ThisForm.Textboxstandard12.Value=[${v(formData?.provider?.crid) || ""}]
ThisForm.Textboxstandard29.Value=[]
ThisForm.Textboxstandard36.Value=[]
ThisForm.Textboxstandard42.Value=[]
ThisForm.Textboxstandard25.Value=[${v(formData?.provider?.mid)}]
ThisForm.Textboxstandard13.Value=[]
ThisForm.Textboxstandard35.Value=[]
ThisForm.Textboxstandard14.Value=[${v(formData?.owner?.crid)}]
ThisForm.Textboxstandard33.Value=[${v(formData?.owner?.anywhere)}]
ThisForm.Textboxstandard34.Value=[]
ThisForm.Checkstandard6.Value=1
ThisForm.Textboxstandard28.Value=[]
ThisForm.Textboxstandard15.Value=[${v(formData?.permit?.nonprofitnumber)}]
ThisForm.Textboxstandard16.Value=[]
ThisForm.Textboxstandard17.Value=[${v(formData?.provider?.repphone)}]
ThisForm.Textboxstandard30.Value=[${v(formData?.provider?.repemail)}]
ThisForm.Textboxstandard18.Value=[${v(formData?.product?.name)}]
ThisForm.Textboxstandard20.Value=[]
ThisForm.Textboxstandard21.Value=[]
ThisForm.Standardcombo1.Value=[Labels]
ThisForm.Standardcombo2.Value=[${v(formData?.permit?.permitType)}]
ThisForm.Standardcombo4.Value=[Ghost Permit]
ThisForm.Standardcombo3.Value=[NCOALink]
ThisForm.Standardcombo5.Value=[]
ThisForm.Standardcombo6.Value=[]
ThisForm.Standardcombo7.Value=[2-tracking File]
ThisForm.Textboxstandard37.Value=[]
ThisForm.Textboxstandard38.Value=[]
ThisForm.Textboxstandard39.Value=[]
ThisForm.Edit1.Value=[${v(formData?.permit?.companyName)}^
${v(formData?.permit?.address)}^
${v(formData?.permit?.city)}, ${v(formData?.permit?.state)} ${v(formData?.permit?.zip)}]
ThisForm.Edit2.Value=[${v(formData?.owner?.companyName)}^
${v(formData?.owner?.address)}^
${v(formData?.owner?.city)}, ${v(formData?.owner?.state)} ${v(formData?.owner?.zip)}]
ThisForm.Edit3.Value=[${v(formData?.provider?.providerName)}^
${v(formData?.provider?.address)}^
${v(formData?.provider?.city)}, ${v(formData?.provider?.state)} ${v(formData?.provider?.zip)}]
ThisForm.Checkstandard1.Value=0
ThisForm.Checkstandard2.Value=0
ThisForm.Checkstandard3.Value=0
ThisForm.Textboxstandard22.Value=[${v(formData?.dropshipname)}]
ThisForm.Textboxstandard32.Value=[${formData.permit.bmeuFacility?.dropdelzpp?.substr(0,5)}-${formData.permit.bmeuFacility?.dropdelzpp?.substr(5,9)}]
ThisForm.CheckStandard7.Value=0
ThisForm.Textboxstandard23.Value=[]
`;

  const handleSubmitJob = async () => {
    if (!finalCSV) {
      alert('No CSV file found.');
      return;
    }
    setLoading(true);

    try {
      const payload = {
        jobDescription: formData.jobDescription || "",
        mailClass: formData.mailClass || "",
        mailDate: formData.mailDate || "",
        mailShape: formData.mailShape || "",
        aspectRatio: formData.aspectRatio || 0,
        political: formData.political || 0,
        imbarcode: formData.imbarcode || 0,
        einduction: formData.einduction || 0,
        ncoa: formData.ncoa || 0,
        alreadyNcoa: formData.alreadyNcoa || 0,
        ncoaDate: formData.ncoaDate || "",
        currentResident: formData.currentResident || 0,
        radiusZip: formData.radiusZip || "",
        radiusMiles: formData.radiusMiles || "",
        restrictStates: formData.restrictStates || "",
        removeMoved: formData.removeMoved || 0,
        sortation: formData.sortation || "",
        reason: formData.reason || "",
        IMbarcode: formData.IMbarcode || 0,
        ballotbox: formData.ballotbox || 0,
        dropship: formData.dropship || 0,
        dropshipname: formData.dropshipname || "",
        growthIncentive: formData.growthIncentive || "",
        no1Trays: formData.no1Trays || "",
        promotions: formData.promotions || 0,
        basepromotions: formData.basepromotions || "",
        smallPallets: formData.smallPallets || "",
        unevenThickness: formData.unevenThickness || 0,
        tallPallets: formData.tallPallets || "",
        uspsJobId: formData.uspsJobId || "",
        addon1: formData.addon1 || "",
        addon2: formData.addon2 || "",
        AccuString: AccuString.trim().replace(/\n\n/g, String.fromCharCode(13, 10)),
        company: authState?.user?.company || "",
        user: authState?.user || "",
        permit: formData.permit || "",
        owner: formData.owner || "",
        product: formData.product || "",
        provider: formData.provider || "",
        poe: formData.poe || formData.provider?.bmeuFacility,
      };

      const form = new FormData();
      form.append('recipient', 'summanusb@gmail.com');
      form.append('formData', JSON.stringify(payload));
      form.append('csvFile', finalCSV, `${formData.jobDescription || 'job'}.csv`);

      await api.post('/jobs/processJob', form, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      toast.success('Job Successfully Uploaded');
      // nav('/dashboard')
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.error || err.message);
    } finally {
      setLoading(false);
    }
  };

  const formatAddress = (address) => {
    if (!address) return null;
    const index = address.indexOf(',');
    if (index === -1) return address;
    const firstLine = address.slice(0, index);
    const rest = address.slice(index + 1).trim();
    return (
      <>
        {firstLine}
        <br />
        {rest}
      </>
    );
  };

  const permitfields = [
    { label: 'Permit Number:', key: '', value: formData?.permit?.permitNumber },
    { label: 'Post Office:', key: '', value: formatAddress(formData?.permit?.bmeu) },
  ];

  const providerfields = [
    { label: 'Address', key: 'telephone', value: <>{formData?.provider?.address} {formData?.provider?.address2}<br />{formData?.provider?.city}, {formData?.provider?.state} {formData?.provider?.zip}</> },
    { label: 'eInduction ', key: 'capsCustRef', value: 'No' },
    { label: 'Seamless Acceptance', key: '', value: 'No' },
  ];

  const ownerfields = [
    { label: 'Nonprofit:', key: '', value: "No" },
  ];

  const handlePrev = () => {
    goToPrevTab();
  };

  return (
    <div className="p-4 max-w-6xl mx-auto font-sans space-y-4" style={{ fontSize: 'clamp(0.9rem, 0.9rem, 1rem)' }}>
      <div style={{ fontSize: 'clamp(1.3rem,1.3rem,1.3rem)', textAlign: 'center' }}>
        Job Description / Title: {formData?.jobDescription}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }} className="md:flex-row md:gap-4">
        <div style={{ display: 'flex', gap: '20px' }}>
          <div className="md:flex-1">
            <span>Mail Class:</span> {formData.mailClass}
          </div>
          <div style={{ flex: '1', textAlign: 'right' }}>File: {csvMeta.name}</div>
        </div>
        <div style={{ display: 'flex', gap: '20px' }}>
          <div style={{ flex: '1' }}>
            <span>Mail Date:</span> {formData.mailDate}
          </div>
          <div style={{ flex: '1', textAlign: 'right' }}>Records: {csvMeta.records}</div>
        </div>
      </div>

      <hr />

      {/* Permit / Provider / Owner */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
        {/* Permit */}
        <div>
          <h4 className="font-semibold mb-1">Permit Info - {formData?.permit?.permitName}</h4>
          <div className="p-2 rounded border border-gray-300 bg-gray-50">
            <p>{formData?.permit?.companyName}</p>
            <p>{formData?.permit?.address} {formData?.permit?.address2}</p>
            <p>{formData?.permit?.city}, {formData?.permit?.state} {formData?.permit?.zip}</p>
          </div>
          {permitfields.map(({ label, key, value }) => (
            <div key={key} style={{ display: 'flex', justifyContent: 'space-between', marginTop: '4px', gap:'16px' }}>
              <div>{label}</div>
              <div style={{ flex:'1.5', textAlign:'right', whiteSpace:'normal', wordBreak:'keep-all', paddingRight:'5px' }}>{value}</div>
            </div>
          ))}
        </div>

        {/* Provider */}
        <div>
          <h4 className="font-semibold mb-1">Mail Service Provider - {formData?.provider?.providerName}</h4>
          <div className="p-2 rounded border border-gray-300 bg-gray-50">
            <p>{formData?.provider?.providerName}</p>
            <p>{formData?.provider?.address} {formData?.provider?.address2}</p>
            <p>{formData?.provider?.city}, {formData?.provider?.state} {formData?.provider?.zip}</p>
          </div>
          {providerfields.map(({ label, key, value }) => (
            <div key={key} style={{ display: 'flex', justifyContent: 'space-between', marginTop: '4px' }}>
              <div>{label}</div>
              <div style={{ flex:'1.5', textAlign:'right', whiteSpace:'normal', wordBreak:'keep-all', paddingRight:'5px' }}>{value}</div>
            </div>
          ))}
        </div>

        {/* Owner */}
        <div>
          <h4 className="font-semibold mb-1">Mail Owner - {formData?.owner?.companyName}</h4>
          <div className="p-2 rounded border border-gray-300 bg-gray-50">
            <p>{formData?.owner?.companyName}</p>
            <p>{formData?.owner?.address} {formData?.owner?.address2}</p>
            <p>{formData?.owner?.city}, {formData?.owner?.state} {formData?.owner?.zip}</p>
          </div>
          {ownerfields.map(({ label, key, value }) => (
            <div key={key} style={{ display: 'flex', gap:'1px', justifyContent:'space-between', marginTop:'4px' }}>
              <div style={{ marginLeft: '8px' }}>{label}</div>
              <div style={{ flex:'1.5', textAlign:'right', whiteSpace:'normal', wordBreak:'keep-all', paddingRight:'5px' }}>{value}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Product */}
      <div>
        <h4 className="font-semibold mb-1">Product Information</h4>
        <div className="p-2 rounded border border-gray-300 bg-gray-50 grid grid-cols-1 md:grid-cols-5 gap-2">
          <div>Product Name: {formData.product?.name}</div>
          <div>Size: {formData.product?.length} X {formData.product?.width}</div>
          <div>Thickness: {formData.product?.thickness}</div>
          <div>Weight: {formData.product?.weight}</div>
          <div>Style: {formData?.mailShape}</div>
        </div>
      </div>

      {/* List Cleaning / Data Cleanup */}
      <div className="mt-4 p-4 border rounded bg-gray-50 space-y-4">
        <h4 className="font-semibold mb-2">List Cleaning Options</h4>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>Are we NCOA’ing the List? {formData.ncoa ? 'Yes' : 'No'}</div>
          {formData.ncoa === false && <div>Already been NCOA’d? {formData.alreadyNcoa === null ? 'N/A' : formData.alreadyNcoa ? 'Yes' : 'No'}</div>}
          {formData.ncoa === false && formData.alreadyNcoa === true && <div>Date of NCOA: {formData.ncoaDate || 'N/A'}</div>}
          {formData.ncoa === false && formData.alreadyNcoa === false && <div>Current Resident Mailing? {formData.currentResident ? 'Yes' : 'No'}</div>}
            
          
        </div>

   <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>Remove all records that moved: {formData.removeMoved ? 'Yes' : 'No'}</div>
            <div>Remove duplicate records: {formData.dedup ? 'Yes' : 'No'}</div>
            <div>Remove bad addresses: {formData.removeBadAddress ? 'Yes' : 'No'}</div>
       </div>



        <div className="border-t pt-2">
          <div className="font-medium mb-1">Address Filtering</div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-1">
            <div>Radius Zipcode: {formData.radiusZip || 'N/A'}</div>
            <div>Radius (Miles): {formData.radiusMiles || '0.0'}</div>
          </div>
      
        </div>

        <div className="border-t pt-2 grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
          <div>
            Do Not Mail (Suppression) List: {formData.dnmMode || 'None'}
            {formData.selectedSuppressionLists && Object.keys(formData.selectedSuppressionLists).length > 0 && (
              <ul className="ml-2 text-[11px] list-disc list-inside">
                {Object.values(formData.selectedSuppressionLists).map((list, idx) => (
                  <div key={idx}>{list.name} ({list.count} addresses)</div>
                ))}
              </ul>
            )}
          </div>
          <div>
            Seed Records: {formData.seedMode || 'None'}
            {formData.selectedSeedLists && Object.keys(formData.selectedSeedLists).length > 0 && (
              <ul className="ml-2 text-[11px] list-disc list-inside">
                {Object.values(formData.selectedSeedLists).map((list, idx) => (
                  <div key={idx}>{list.name} ({list.count} seeds)</div>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>

      {/* Buttons */}
      <div className="flex justify-end">
        <button style={{marginRight:'30px'}} onClick={handlePrev} className="bg-blue-500 text-white px-4 py-1 rounded hover:bg-blue-600">Prev &lt;</button>
        <button onClick={handleSubmitJob} disabled={loading} className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-1 rounded text-sm font-semibold">{loading ? 'Submitting...' : 'Submit Presort'}</button>
      </div>
    </div>
  );
};

export default ReviewTab;